import { render, staticRenderFns } from "./ZrDetails.vue?vue&type=template&id=3820e23c"
import script from "./ZrDetails.vue?vue&type=script&lang=js"
export * from "./ZrDetails.vue?vue&type=script&lang=js"
import style0 from "./ZrDetails.vue?vue&type=style&index=0&id=3820e23c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports